import api from '../lib/axios';
export async function getContributors() {
    const { data } = await api.get('/api/admin/contributors');
    return data;
}
/** `message` distingue un compte créé (invitation envoyée) d'un compte existant auquel l'accès est ajouté. */
export async function createContributor(body) {
    const { data } = await api.post('/api/admin/contributors', body);
    return data;
}
export async function updateContributor(userId, body) {
    await api.patch(`/api/admin/contributors/${userId}`, body);
}
/** `message` indique si le compte est supprimé ou si son compte d'habitant est conservé. */
export async function deleteContributor(userId) {
    const { data } = await api.delete(`/api/admin/contributors/${userId}`);
    return data.message;
}
export async function resendContributorInvitation(userId) {
    await api.post(`/api/admin/contributors/${userId}/resend-invitation`);
}
